import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';

const DAY_CHECK_INTERVAL_MS = 60000;

const getTodayString = () => DateTime.local().toFormat('yyyy-MM-dd');

/**
 * Today's date as `yyyy-MM-dd`, kept up to date past midnight.
 * A POS left open overnight would otherwise keep querying yesterday's bookings.
 */
export const useTodayString = (): string => {
  const [todayString, setTodayString] = useState(getTodayString);

  useEffect(() => {
    const interval = setInterval(() => {
      const next = getTodayString();
      // Returning the same value skips the re-render on all but the day change
      setTodayString((current) => (current === next ? current : next));
    }, DAY_CHECK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);

  return todayString;
};
